<template>
  <div
    :class="[
      $style.wrapper,
      $style[`variant-${variant}`]
    ]"
  >
    #pick8team
    <span>
      {{ $t('footer', { year }) }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'light',
      required: false,
    },
  },
  data() {
    return {
      year: new Date().getFullYear(),
    }
  },
}
</script>

<style module lang="scss">
  @import "../assets/scss/variables";

  .wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: .5rem;

    span {
      padding-top: .25rem;
      font-size: $font-size-tiny;
      text-align: center;
    }

    &.variant-light {
      color: $color-carbon;
      background-color: $color-white;
    }
    &.variant-dark {
      color: $color-white;
      background-color: $color-midnight-blue;
    }
  }
</style>
